import Vue from 'vue'
import Vuex from 'vuex'
// import VuexAlong from 'vuex-along'

Vue.use(Vuex)

const mutations = {
  getNumber (state, params) {
    state.number = params
  },
  getFGid (state, params) {
    state.FGid = params
  },
  getType(state, params){
    state.type = params
  },
  getOutData(state, params){
    state.outData = params
  },
  getisHttp(state,params){
    state.isHttp = params
  },
  getusername(state,params){
    state.username = params
  },
  getBeforeCount(state,params){
    state.beforeCount = params
  }
}

export default new Vuex.Store({
  state:{
    //装箱单
    number:'',
    FGid:'',
    type:'',
    outData:[],
    isHttp:true,
    username:"",
    beforeCount:""
  },
  mutations,
  // plugins: [VuexAlong({
  //   name: "hello-vuex-along",
  //   session: {
  //     // 保存模块 ma 中的 a1 到 sessionStorage
  //     list: ["state"]
  //   },
  // })]
})

